import script from "./CaskCnIdCardGenerator.vue?vue&type=script&setup=true&lang=js"
export * from "./CaskCnIdCardGenerator.vue?vue&type=script&setup=true&lang=js"

import "./CaskCnIdCardGenerator.vue?vue&type=style&index=0&id=633a5ee2&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-633a5ee2"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QRadio from 'quasar/src/components/radio/QRadio.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QRadio,QInput,QBtn});
